export default __webpack_public_path__ + "static/5chka-4752e38dc142de768468447db5c4f6da.svg";